import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';

import { firebaseStorage } from '@/configs/firebase.config';

const fileExtension = (name: string): string => {
  const ext = /\.([a-zA-Z0-9]+)$/.exec(name)?.[1];
  return ext ? ext.toLowerCase() : 'bin';
};

/**
 * Uploads a file to Firebase Storage under `folder/` and resolves with its download URL.
 * Mirrors the mobile app's storage service so both write to the same bucket.
 */
export const uploadImage = async (folder: string, file: File): Promise<string> => {
  const unique = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const storageRef = ref(firebaseStorage, `${folder}/${unique}.${fileExtension(file.name)}`);
  await uploadBytes(storageRef, file, { contentType: file.type });
  return getDownloadURL(storageRef);
};
